<script>
export default {
  props: {
    root: {
      type: [Document, Element],
      default: null,
    },
    records: {
      type: Array,
      default: () => [],
    },
    estimatedHeight: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      clientHeight: 400,
      scrollTop: 0,
    }
  },
  computed: {
    lazyRendering() {
      const padding = 200
      const h = 2 * this.clientHeight + padding + this.scrollTop
      return this.records.map((rec, i) => ({
        render: i < Math.floor(h / this.estimatedHeight),
        row: rec,
      }))
    },
  },
  watch: {
    root() {
      this.clientHeight = this.root?.clientHeight ?? 400
      this.scrollTop = this.root?.scrollTop ?? 0
    },
  },
  render() {
    return this.$slots.default({
      lazyRecords: this.lazyRendering,
    })
  },
}
</script>
